import React, { useEffect, useState } from 'react'
import { Btn, CustomInputTextArea, CustomModal } from '../../../../components'
import { errorHandler } from '../../../../services/util/error.service'
import { putFleetObservation } from '../../../../services/api/https/deliveries/envio-rota.http'

export default function ObservacoesModal({ visible, fleet, onResponse }) {
  const [observacoes, setObservacoes] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setObservacoes(fleet ? fleet.observation : '')
  }, [visible])

  // Events

  const onBtnSalvarClick = async () => {
    try {
      setIsLoading(true)
      const response = await putFleetObservation(fleet.fleet_id, observacoes)
      onResponse('successObs', response)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  // Render
  return (
    <CustomModal
      header={'Observações Mapa de Carga'}
      isVisible={visible}
      width={600}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <CustomInputTextArea
            rows={5}
            label="Observações"
            marginTop={0}
            value={observacoes}
            onChange={value => {
              setObservacoes(value)
            }}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClick} isLoading={isLoading}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
